import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1000px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-[500px] mx-auto">
            按类型和热度快速筛选你感兴趣的影视内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicsData.map((item) => {
            const colorClass = item.color === 'primary'
              ? 'bg-primary-100 text-primary-700 hover:bg-primary-500 hover:text-background-50 border-primary-200'
              : item.color === 'accent'
              ? 'bg-accent-100 text-accent-700 hover:bg-accent-500 hover:text-background-50 border-accent-200'
              : 'bg-secondary-100 text-secondary-700 hover:bg-secondary-500 hover:text-background-50 border-secondary-200';

            return (
              <div
                key={item.id}
                className={`group px-4 py-2.5 md:px-5 md:py-3 rounded-full border cursor-pointer transition-all flex items-center gap-2 ${colorClass}`}
              >
                <span className="text-sm md:text-base font-medium whitespace-nowrap">
                  {item.name}
                </span>
                <span className="text-[10px] md:text-xs opacity-70 whitespace-nowrap">
                  {item.count}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}